/* eslint-disable @next/next/no-img-element */
import Image from 'next/image'
import styles from './challanKeyFeatures.module.scss'

const ChallanKeyFeatures = ({ content }) => {
  const keyFeatures = content?.KeyFeatures || []

  return (
    <div className={styles.keyFeaturesContainer}>
      {keyFeatures?.map(item => {
        const iconUrl = item?.KeyFeatureIcon?.data?.attributes?.url
        const description = item?.keyFeatureServiceProvided

        return (
          <div className={styles.keyFeatureItem} key={item?.id}>
            {iconUrl && (
              <Image src={iconUrl} alt="Key Feature Icon" width={32} height={32} className={styles.keyFeatureIcon} />
            )}
            <p className={styles.keyFeatureDescription}>{description}</p>
          </div>
        )
      })}
    </div>
  )
}

export default ChallanKeyFeatures
